import { useMutation } from '@tanstack/react-query';
import { MailCheck } from 'lucide-react';
import { api, errorMessage } from '../lib/api';
import { useAuth } from '../lib/auth';
import { Button } from './ui';

/** Above every page until the signed-in account confirms its email address (accounts made at /sign-up). */
export function ConfirmEmailBanner() {
  const { me } = useAuth();
  const resend = useMutation({ mutationFn: () => api.post<{ ok: true; email: string }>('/auth/verify-email/resend') });
  if (!me || me.user.emailVerified !== false) return null;
  return (
    <div className="mb-6 flex flex-wrap items-center justify-between gap-x-4 gap-y-2 rounded-lg border border-amber-200 bg-amber-50 px-4 py-2.5 text-sm text-amber-950 print:hidden">
      <p className="flex items-center gap-2">
        <MailCheck className="size-4 shrink-0 text-amber-600" />
        <span>
          <strong>Confirm your email.</strong> We sent a link to {me.user.email}, so we can send you trial and billing updates.
        </span>
      </p>
      {resend.isSuccess ? (
        <span className="text-xs">Sent a new link to {resend.data.email}.</span>
      ) : (
        <span className="flex items-center gap-3">
          {resend.error && <span className="text-xs text-red-700">{errorMessage(resend.error)}</span>}
          <Button size="sm" loading={resend.isPending} onClick={() => resend.mutate()}>
            Send a new link
          </Button>
        </span>
      )}
    </div>
  );
}
